export const COMMAND_MENU_BOTTOM_OFFSET = 64;
export const COMMAND_MENU_BOTTOM_EXPANDED_OFFSET = 150;
export const COMMAND_MENU_BOTTOM_MOBILE_OFFSET = 225;
export const COMMAND_MENU_LEFT_OFFSET = 35;
export const COMMAND_MENU_WIDTH = 520;
export const COMMAND_MENU_DATA_TEST_ID = 'live-assistant-command-menu';
export const COMMAND_MENU_LOADER_TEST_ID = 'live-assistant-command-menu-loader';
